import { useQuery } from '@tanstack/react-query'
import { useQueryClient } from '@tanstack/react-query'
import { updateEmailConfiguration } from '../../services/configuration.service'
import { QueryKeys } from '../../../../constants/queryKeys.constants'
import { EmailConfigurationType } from '../types/emailConfiguration.types'
import { getEmailConfiguration } from '../../services/configuration.service'
import { ConfigurationCategory } from '../../types/configuration.types'

export const useEmailConfiguration = () => {
  const queryClient = useQueryClient()

  const { data: configuration, isLoading } = useQuery({
    queryKey: [QueryKeys.CONFIGURATION, ConfigurationCategory.EMAIL],
    queryFn: getEmailConfiguration,
  })

  const update = async (data: Partial<EmailConfigurationType>) => {
    await updateEmailConfiguration(data)
    queryClient.invalidateQueries({ queryKey: [QueryKeys.CONFIGURATION, ConfigurationCategory.EMAIL] })
  }

  return {
    companyName: configuration?.companyName || '',
    instaUrl: configuration?.instaUrl || '',
    facebookUrl: configuration?.facebookUrl || '',
    websiteUrl: configuration?.websiteUrl || '',
    ownerEmail: configuration?.ownerEmail || '',
    managerEmail: configuration?.managerEmail || '',
    adminEmail: configuration?.adminEmail || '',
    adminSecondaryEmail: configuration?.adminSecondaryEmail || '',
    newBookingEmailTemplate: configuration?.newBookingEmailTemplate || '',
    nextDayBookingsEmailTemplate: configuration?.nextDayBookingsEmailTemplate || '',
    canceledSpotEmailTemplate: configuration?.canceledSpotEmailTemplate || '',
    refundedSpotEmailTemplate: configuration?.refundedSpotEmailTemplate || '',
    isLoading,
    update,
  }
}
